import EditPurchaseOrders from './forms.editPurchaseOrder'
import { SignIn } from './forms.signIn'
import { SignUp } from './forms.signUp'
import { ContactUs } from './forms.contactUs'
import { ForgotPassword } from './forms.forgotPassword'
import { User } from './forms.user'
import { AddEditHospital } from './forms.addEditHospital'
import { RFPCreation } from './forms.rfpCreation'
import { CreateGroupChat } from './forms.createGroupChat'
import { EditGroupChat } from './forms.editGroupChat'
import { FANumber } from './forms.2FANumber'
import { FACode } from './forms.2FACode'
import { ContactUsLanding } from './forms.contactUsLanding'
import { PRSCreation } from './forms.prsCreation'
import { PRSParticipants } from './forms.prsParticipants'
import { SurveyQuestions } from './forms.surveyQuestions'
import { CompleteProfile } from './forms.completeProfile'
import { GpoDetails } from './forms.gpoDetails'
import { EditFeesForm } from './forms.editFees'
import { EditCommunityFees } from './forms.editCommunityFees'
import { ManageCategoryAssignment } from './forms.manageCategoryAssignment'
import { TForms } from './Forms.d'
import './styles.scss'
import { CommunityDetails } from './forms.communityDetails'

const Forms: TForms = () => 'Please, provide form component'

Forms.SignIn = SignIn
Forms.SignUp = SignUp
Forms.ContactUs = ContactUs
Forms.ForgotPassword = ForgotPassword
Forms.User = User
Forms.AddEditHospital = AddEditHospital
Forms.RFPCreation = RFPCreation
Forms.CreateGroupChat = CreateGroupChat
Forms.EditGroupChat = EditGroupChat
Forms.EditPurchaseOrders = EditPurchaseOrders
Forms.FANumber = FANumber
Forms.FACode = FACode
Forms.ContactUsLanding = ContactUsLanding
Forms.PRSCreation = PRSCreation
Forms.PRSParticipants = PRSParticipants
Forms.SurveyQuestions = SurveyQuestions
Forms.CompleteProfile = CompleteProfile
Forms.GpoDetails = GpoDetails
Forms.EditCommunityFees = EditCommunityFees
Forms.EditFees = EditFeesForm
Forms.ManageCategoryAssignment = ManageCategoryAssignment
Forms.CommunityDetails = CommunityDetails

export default Forms
